import { getBarcode } from '../services/api';

export const handleBarcodeOpen = async (barcodeId: string) => {
  const { data } = await getBarcode(barcodeId);
  const fileURL = URL.createObjectURL(data);
  window.open(fileURL);

  return fileURL;
};
